/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import type { ExpandedEvent } from '@features/agenda/utils/expand-recurrence';

/**
 * Whether an expanded event belongs to a recurring master.
 * @param event - The expanded event.
 * @returns True when the event has recurrence rules or a recurring parent.
 */
export const isRecurring = (event: ExpandedEvent): boolean =>
  Boolean(event.recurrence && event.recurrence.length > 0) ||
  Boolean(event.recurring_event_id);

/**
 * The id used for API mutations (master id for recurring instances).
 * @param event - The expanded event.
 * @returns The master event id when present, otherwise the event id.
 */
export const mutationTargetId = (event: ExpandedEvent): string =>
  event.master_event_id ?? event.event_id;
